export enum AppointmentStatusDisplay {
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  APPOINTMENT_LOST = 'APPOINTMENT_LOST',
  APPOINTMENT_DONE = 'APPOINTMENT_DONE',
  PAYMENT_DONE = 'PAYMENT_DONE',
  EXPIRED_COUPON = 'EXPIRED_COUPON',
  REVERSED_COUPON = 'REVERSED_COUPON',
  APPOINTMENT_CANCELED = 'APPOINTMENT_CANCELED',
  AWAITING_PURCHASE = 'AWAITING_PURCHASE',
}
